export const ENGLISH = 'en';
export const FRENCH = 'fr';
